export default "__VITE_ASSET__59d3a6e3__"